import Text, {TEXT_TYPES} from '@frontend/ui-kit/Components/Text';
import Icon, {ICON_TYPES} from '@frontend/ui-kit/Components/Icon';
import DropdownWrapper, {DROPDOWN_WRAPPER_ALIGNING} from '@frontend/ui-kit/Components/DropdownWrapper';
import styles from './index.module.scss';

const UserInfo = () => {
    const getUserActionsList = ({onClose}: {onClose: () => void}) => {
        const onDashboardClick = () => {
            console.log('Dashboard clicked');
            onClose();
        };

        const onSignOutClick = () => {
            console.log('Sign out clicked');
            onClose();
        };

        return (
            <div className={styles['user-actions-list']}>
                <div data-testid='dashboard-item' className={styles['user-actions-list__item']} onClick={onDashboardClick}>
                    <Icon className={styles['user-actions-list__icon']} type={ICON_TYPES.switch}/> Dashboard
                </div>
                <div data-testid='sign-out-item' className={styles['user-actions-list__item']} onClick={onSignOutClick}>
                    <Icon className={styles['user-actions-list__icon']} type={ICON_TYPES.powerSignOut}/> Sign out
                </div>
            </div>
        );
    };

    const dropdownWrapperProps = {
        className: styles['user-avatar'],
        aligning: DROPDOWN_WRAPPER_ALIGNING.right,
        renderDropdownInitiator: () => <Icon data-testid='avatar' className={styles['user-avatar__icon']} type={ICON_TYPES.avatar}/>
    };

    return (
        <div data-testid='user-info' className={styles['user-info']}>
            <div className={styles['user-info-profile']}>
                <div>
                    <Text type={TEXT_TYPES.helperBold} className={styles['user-info-profile__name']}>User Name</Text>
                    <Text type={TEXT_TYPES.caption} className={styles['user-info-profile__role']}>ADMIN</Text>
                </div>

                <DropdownWrapper {...dropdownWrapperProps}>
                    {getUserActionsList}
                </DropdownWrapper>
            </div>
        </div>
    );
};

export {UserInfo as TestableUserInfo};
export default UserInfo;
